import { TournamentState, utils } from '@ps/poker-games-tile-mappers';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { TournamentStateTranslations, getTimeDiff, getTimeFormatProps } from '@swf/poker';

import { TXTCLI_In_N0_min, TXTCLI_Late_Reg_XN0X } from './useStartStateFormatter.messages.json';

const useStartStateFormatter = () => {
  const timeZoneName = useSelector(select.timeZone.getTimeZoneName);
  const { formatMessage, formatDate } = useIntl();

  const formatStartState = (state: TournamentState, regEndInt: number, whenStartInt: number) => {
    const { nowTimestamp, lateRegTs, startTs } = utils.mttUtils.getMttStartTime({
      timeZone: timeZoneName,
      startTimestamp: whenStartInt,
      lateRegTimestamp: regEndInt
    });
    const nowTimeMs = nowTimestamp * 1000;
    const startTimeMs = startTs * 1000;

    let formattedValue = formatDate(startTimeMs, {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    }).replace(',', '');

    switch (state) {
      case TournamentState.ANNOUNCED:
      case TournamentState.REGISTERING: {
        const { days, hours, minutes } = getTimeDiff(startTimeMs, nowTimeMs);
        if (!days && !hours) {
          formattedValue = formatMessage(TXTCLI_In_N0_min, {
            0: minutes
          });
        }
        return formattedValue;
      }
      case TournamentState.LATE_REGISTRATION: {
        const { translation, values } = getTimeFormatProps(lateRegTs * 1000, nowTimeMs);
        formattedValue = formatMessage(translation, values);
        return formatMessage(TXTCLI_Late_Reg_XN0X, { 0: formattedValue });
      }
      case TournamentState.COMPLETED:
      case TournamentState.CANCELLED:
      case TournamentState.FULL:
      case TournamentState.PAUSED:
      case TournamentState.RESTRICTED:
      case TournamentState.RUNNING:
      case TournamentState.SEATING:
        return formatMessage(TournamentStateTranslations?.[state]);
      default:
        return formattedValue;
    }
  };

  return { formatStartState };
};

export default useStartStateFormatter;
